import { Box, Typography } from '@mui/material';
import { PageBase } from '../PageBase';
import { theme } from '@/styles/theme';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const DeleteAccount = () => {
  const { t } = useTranslation('deleteAccount');
  const navigate = useNavigate();

  return (
    <PageBase
      title={t('delete_account_title')}
      onBackClick={() => navigate(-1)}
      paddingInline={0}
    >
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box>
          <Typography
            sx={{
              fontSize: '1.8rem',
              fontWeight: 600,
              color: theme.palette.primary.main,
            }}
          >
            {t('title')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('description')}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 600,
            }}
          >
            {t('section_title')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
              whiteSpace: 'pre-line',
            }}
          >
            {t('section_description')}
          </Typography>
        </Box>
      </Box>
    </PageBase>
  );
};
